const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCategoryView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Category",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M22.336,22.143H1.664c-0.369,0-0.668-0.299-0.668-0.668v-8.256 c0-0.369,0.299-0.667,0.668-0.667h20.672c0.369,0,0.668,0.299,0.668,0.667v8.256C23.004,21.844,22.705,22.143,22.336,22.143z  M22.336,11.261H1.664c-0.369,0-0.668-0.299-0.668-0.668V2.36c0-0.369,0.299-0.668,0.668-0.668h20.672 c0.369,0,0.668,0.299,0.668,0.668v8.233C23.004,10.962,22.705,11.261,22.336,11.261z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCategoryView);
export default __webpack_public_path__ + "static/media/ic_category_view.3afeb68d9189582fcba095734f86b822.svg";
export { ForwardRef as ReactComponent };